module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Abbreviations"
    }
  }, [_vm._v("Abbreviations and Glossary")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter1"
    }
  }, [_c('span', {
    staticClass: "sp_toc-chap"
  }, [_vm._v("Chapter 1")]), _vm._v(" The British Military Mission to Poland in 1939")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc-chap"
  }, [_vm._v("Chapter 2")]), _vm._v(" The Special Operations Executive and Poland")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc-chap"
  }, [_vm._v("Chapter 3")]), _vm._v(" British Subversion in French East Africa, 1941–42")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc-chap"
  }, [_vm._v("Chapter 4")]), _vm._v(" On Secret Service for the Duce, 1941–43")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc-chap"
  }, [_vm._v("Chapter 5")]), _vm._v(" British Radio Security and Intelligence, 1939–43")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc-chap"
  }, [_vm._v("Chapter 6")]), _vm._v(" J.C. Masterman and the Security Service, 1940–72")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0